import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumToArray',
  standalone: false,
})
export class EnumToArrayPipe implements PipeTransform {
  transform<T>(value: { [key: string]: T | string }): Array<{ value: T; label: string }> {
    return Object.keys(value)
      .map(key => ({
        label: key
          .replace(/([A-Z])/g, ' $1')
          .replace(/_/g, ' ')
          // Remove white space from acronyms
          // (Where a capital leter is followed by a space, then a capital letter followed by a space or end of line)
          .replace(/([A-Z]){1}\s([A-Z]){1}(\s|$)/g, '$1$2')
          .trim(),
        value: value[key],
      }))
      .filter((entry): entry is { value: T; label: string } => isNaN(+entry.label));
  }
}
